<template>
  <div class="container">
    <div class="list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多的报告了" @load="onLoad">
        <div class="reportList flexCenter flexBetween line-b-E5E5E5 bg-fff" v-for="(item,index) in reportList" :key="index" @click="reportDetail(item.auditId)" v-if="index<3">
          <div class="listItem flex1">
            <p>审核日期：{{item.optTime}}</p>
            <p class="mt10" v-if="item.positiveNum">异常数量：<span class="color-red">{{item.positiveNum}} &nbsp;</span>个异常指标</p>
          </div>
          <img src="@/assets/images/arrow_right.png" alt="" class="arrow_right ml5">
        </div>
      </van-list>
    </div>
    <div v-if="isShowEmit">
      <van-empty class="custom-image" :image="emptyImg" description="没有数据" />
    </div>
  </div>
</template>
<script>
  import { Button,Toast,List,Empty} from "vant";
  import GoTop from "@/components/GoTop";
  export default {
  name: 'ReportList',
  components: {
    [Toast.name]:Toast,
    [Button.name]:Button,
    [List.name]:List,
    [Empty.name]:Empty,
    'v-goTop': GoTop,
  },
  data() {
    return {
      loading: false,
      finished: false,
      reportList:[],
      page:1,
      limit:10,
      isShowEmit:false,
      emptyImg:require('@/assets/images/empty.png'),
      scroll_top: '',
      msgFormSon: '',
    }
  },
  watch: {
    
  },
  created() {
    
  },
  methods: {
    onLoad() {
      setTimeout(() => {
        this.getList()
        this.loading = true
      }, 1000);
    },
    getList(){
      $.ajax({
        url: this.GLOBAL.url + '/wx/listReport',
        type: 'get',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        data: {
          pageNum:this.page,
          pageSize:this.limit,
          queryTop:0,//0包含首页显示与未显示 1首页显示的
        },
        success: (res) => {
          if (res.code == 200) {
            this.loading = false;
            this.reportList = this.reportList.concat(res.data.list);
            this.page ++;
            //没有数据
            if (this.reportList.length === 0 && this.page === 1) {
              this.isShowEmit = true;
            };
            //是否最后一页
            if(res.data.isLastPage){
              this.finished = true;
            };
          } else {
            Toast(res.msg)
          };
        },
        error: (e) => {
          console.log(e);
        }
      })
    },
    getMsgFormSon(data) {
      var self = this;
      self.msgFormSon = data;
      let timer = null;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (self.msgFormSon > 0) {
          self.msgFormSon -= 50;
          $('#roll').scrollTop(self.msgFormSon)
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
        }
      });
    },
    reportDetail(id){
      this.$router.push({name:'ReportDetail',query:{id:id}})
    }
  },
  computed: {

  },
}</script>
<style type="text/css" scoped>
.container {
  width: 100%;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

.reportBox {
  width: 95%;
  margin-left: auto;
  margin-right: auto;
  padding: 0.533333rem 0;
  border: 0.026667rem solid #e0e0e0; /* Lighter grey border */
  border-radius: 0.4rem; /* Slightly increased border-radius */
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05); /* Softer shadow */
}

.reportList {
  margin-left: 0.266667rem;
  padding-right: 0.266667rem;
}

.listItem {
  padding: 0.266667rem 0;
}

.arrow_right {
  display: inline-block;
  width: 0.533333rem;
  height: 0.533333rem;
}

::v-deep .custom-image .van-empty__image {
  width: 2.4rem; /* Consistent with Index.vue */
  height: 2.4rem; /* Consistent with Index.vue */
}
</style>